import styled from 'styled-components';

import { tabletAndAbove } from 'style/mediaQuery';

import { SBHorizontal } from '../flex';

export const Table = styled.div`
  padding: 0 var(--double-unit);
  background-color: var(--c-nd-100);
  @media ${tabletAndAbove} {
    border-radius: var(--unit);
  }
`;

export const Row = styled(SBHorizontal)`
  position: relative;
  width: 100%;
  align-items: center;
  padding: var(--intermediate-unit) 0;
  & + & {
    border-top: solid 1px var(--c-nd-200);
  }
`;
